import React, { useEffect, useState } from "react";
import { DatePicker } from "rsuite";
import "rsuite/dist/rsuite.min.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import Select from "react-select";
import { TimePicker } from "antd";
import "antd/dist/reset.css";
import {
  getActiveUsersWithCompleteSignup,
  getActiveProvidersForAppointment,
} from "../config/url";
import useFetchData from "../hooks/useFetchData";
import { config } from "../config/config";
import { useSelector } from "react-redux";
import { useProviderClients } from "./Clients";
const dayjs = require("dayjs");

const EditAppointment = ({
  setShowEditAppointment,
  appointmentData,
  fetchAppointmentData,
}) => {
  const user = useSelector((state) => state?.user);

  const [date, setDate] = useState(null);
  const [dbtime, setDbTime] = useState("");
  const [duration, setDuration] = useState(30);
  const [selectedUser, setSelectedUser] = useState(null);
  const [selectedProvider, setSelectedProvider] = useState(null);
  const [showForm, setShowForm] = useState(true);
  const [time, setTime] = useState(
    dayjs(new Date(appointmentData.appointmenttime))
  );

  const businessId = user.user?.businessId;
  const businessIdentifier = user.user?.businessIdentifier;
  const currentUserProviderId = user.user?.providerId;
    
  // Fetch provider clients
  const { data: usersData, loading: usersLoading, error: usersError } =
    useProviderClients({
      providerId: currentUserProviderId,
      businessId,
      businessIdentifier,
      page: 1,
      limit: 500,
      status: "Active",
    });

  const providersData = useFetchData(
    `${getActiveProvidersForAppointment}?businessId=${businessId}&businessIdentifier=${businessIdentifier}`,
    config
  );

  // Pre-fill form data when editing
  useEffect(() => {
    if (appointmentData) {      
      setDate(new Date(appointmentData.appointmenttime));
      setDbTime(convertUTCToLocal(appointmentData.appointmenttime));
      setDuration(appointmentData.sessionLength);
      setSelectedUser({
        value: appointmentData.user_fk,
        label: `${appointmentData.user.firstname} ${appointmentData.user.lastname}`,
      });
      setSelectedProvider({
        value: appointmentData.specialistid,
        label: `${appointmentData.health_specialist.firstname} ${appointmentData.health_specialist.lastname}`,
      });
    }
  }, [appointmentData]);

  // Force z-index for picker popups when modal is open
  useEffect(() => {
    const forceZIndex = () => {
      const pickerPopups = document.querySelectorAll('.rs-picker-popup');
      pickerPopups.forEach(popup => {
        popup.style.zIndex = '10001';
      });
    };

    // Run immediately
    forceZIndex();

    // Set up a mutation observer to watch for new picker popups
    const observer = new MutationObserver(forceZIndex);
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    return () => observer.disconnect();
  }, []);

  console.log(
    appointmentData.appointmentdate,
    "appointmentData.appointmentdate"
  );

  const convertUTCToLocal = (utcTime) => {
    const date = new Date(utcTime);

    // Use toLocaleTimeString to automatically adjust to the local time zone
    const formattedTime = date.toLocaleTimeString("en-GB", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: false, // Use 24-hour format
    });

    return formattedTime;
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    // Check if the appointment is in progress
    if (isAppointmentInProgress()) {
      toast.error(
        "This session is currently in progress and cannot be edited or deleted. Please view the session details instead.",
        {
          position: "top-right",
          autoClose: 5000,
        }
      );
      return;
    }

    if (!selectedUser || !selectedProvider) {
      toast.error(
        "Please select a provider and a user to update the session.",
        {
          position: "top-right",
          autoClose: 5000,
        }
      );
      return;
    }

    if (!date || !time) {
      toast.error("Please select a date and time to update the session", {
        position: "top-right",
        autoClose: 5000,
      });
      return;
    }

    const authToken = user.user?.token;

    const clientTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    try {
      const response = await axios.put(
        `${process.env.REACT_APP_BASE_URL}/appointment/update/${appointmentData._id}`,
        {
          appointmentId: appointmentData._id,
          selectedUser: selectedUser.value,
          selectedProvider: selectedProvider.value,
          date,
          dbtime,
          duration,
          timeZone: clientTimeZone,
        },
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        }
      );

      if (response.data.success) {
        fetchAppointmentData();
        toast.success(response.data.message);
        setTimeout(() => {
          setShowEditAppointment(false);
        }, 3000);
        return;
      } else {
        toast.error("Could not update the appointment.");
      }
    } catch (error) {
      if (error.message === "Network Error") {
        toast.error(
          "We’re having trouble processing your request. Please check your internet connection and try again.",
          {
            position: "top-right",
            autoClose: 5000,
          }
        );
      } else {
        toast.error(
          error.response?.data?.message || "Error updating appointment"
        );
      }
    }
  };

  const handleClose = () => {
    setShowForm(false);
    setShowEditAppointment(false);
  };

  // Check if the appointment is currently in progress
  const isAppointmentInProgress = () => {
    const appointmentTime = new Date(appointmentData.appointmenttime);
    const currentTime = new Date();
    const endTime = new Date(appointmentTime);
    endTime.setMinutes(endTime.getMinutes() + appointmentData.sessionLength); // Add session length to get end time

    return currentTime >= appointmentTime && currentTime <= endTime;
  };

  function extractTime(timeString) {
    // Regular expression to match HH:MM format
    const timeRegex = /(\d{2}:\d{2})/;
    const match = timeRegex.exec(timeString);

    if (match) {
      return match[1]; // Extract the matched time (e.g., "10:15")
    } else {
      return null; // No match found
    }
  }

  // Return null if the form is closed
  if (!showForm) return null;

  return (
    <div style={containerStyle}>
      <form onSubmit={handleSubmit}>
        <div style={cardStyle}>
          {/* Title and Close Button */}
          <div style={headerStyle}>
            <h3 style={sectionTitleStyle}>Edit Appointment</h3>
            <button style={closeButtonStyle} onClick={handleClose}>
              X
            </button>
          </div>

          {/* Date, Time, Duration */}
          <div style={formRowStyle}>
            <div style={{ flex: 1, marginRight: "0px" }}>
              <DatePicker
                value={date}
                onChange={setDate}
                format="MM/dd/yyyy"
                className="datepickerBorder"
                style={{
                  ...inputStyle,
                  width: "100%",
                  borderRadius: "8px 0px 0px 8px",
                }}
              />
            </div>
            <div style={{ flex: 1, marginRight: "10px", width: "50%" }}>
              <TimePicker
                minuteStep={15}
                hourStep={1}
                format="h:mm a"
                use12Hours
                value={time}
                onChange={(value) => {
                  if (value) {
                    setTime(value);
                    setDbTime(extractTime(value?.$d));
                  } else {
                    setTime(null);
                  }
                }}
                style={{
                  ...inputStyle,
                  borderRadius: "0px 8px 8px 0px",
                  borderLeft: "1px solid #ccc",
                }}
              />
            </div>
            <div style={{ flex: 1, paddingRight: "0px" }}>
              <select
                value={duration}
                onChange={(e) => setDuration(e.target.value)}
                style={{ ...inputStyle, width: "50%" }}
              >
                <option value="30">30</option>
                <option value="60">60</option>
              </select>
              <span style={{ marginLeft: "8px" }}>mins</span>
            </div>
          </div>

          {/* Select User */}
          <div style={formGroupStyle}>
            <Select
              value={selectedUser}
              onChange={setSelectedUser}
              options={
                usersData && usersData.length > 0
                  ? usersData.map((user) => ({
                      value: user._id,
                      label: `${user.name}`,
                    }))
                  : []
              }
              placeholder="Select User"
              isSearchable
              styles={selectStyle}
            />
          </div>

          {/* Select Provider */}
          <div style={formGroupStyle}>
            <Select
              value={selectedProvider}
              onChange={setSelectedProvider}
              options={
                providersData && providersData.length > 0
                  ? providersData.map((provider) => ({
                      value: provider._id,
                      label: `${provider.firstname} ${provider.lastname}`,
                    }))
                  : []
              }
              placeholder="Select Provider"
              isSearchable
              styles={selectStyle}
            />
          </div>

          {/* Submit Button */}
          <div style={buttonContainerStyle}>
            <button type="submit" style={buttonStyle}>
              Save
            </button>
          </div>
        </div>
      </form>
    </div>
  );
};

// Same styles as AddAppointment.js
const containerStyle = {
  maxWidth: "450px",
  margin: "50px auto",
  fontFamily: "Poppins, sans-serif",
};

const cardStyle = {
  backgroundColor: "white",
  borderRadius: "12px",
  boxShadow: "0 0 15px rgba(0, 0, 0, 0.1)",
  padding: "20px",
  width: "120%",
};

const headerStyle = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
};

const sectionTitleStyle = {
  color: "#333",
  textAlign: "left",
  fontWeight: "700",
  fontSize: "16px",
  fontFamily: "Poppins",
  textTransform: "uppercase",
  letterSpacing: "0.5px",
};

const closeButtonStyle = {
  borderRadius: "50rem",
  border: "none",
  width: "25px",
  height: "25px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  fontSize: "14px",
  color: "#808080",
  cursor: "pointer",
};

const formGroupStyle = {
  marginBottom: "20px",
};

const inputStyle = {
  width: "100%",
  padding: "10px",
  borderRadius: "8px",
  border: "none",
  backgroundColor: "#F4F4F6",
  height: "45px",
  boxSizing: "border-box",
  color: "#808080",
};

const formRowStyle = {
  display: "flex",
  justifyContent: "space-between",
  marginBottom: "20px",
};

const buttonContainerStyle = {
  textAlign: "center",
  marginTop: "20px",
};

const buttonStyle = {
  backgroundColor: "#27B99A",
  color: "white",
  padding: "12px 24px",
  border: "none",
  borderRadius: "8px",
  cursor: "pointer",
  marginTop: "20px",
  fontWeight: "600",
  fontSize: "14px",
  textTransform: "uppercase",
  width: "100%",
  transition: "all 0.2s",
};

const selectStyle = {
  control: (provided) => ({
    ...provided,
    borderRadius: "8px",
    borderColor: "#ccc",
    backgroundColor: "#F4F4F6",
    height: "45px",
  }),
};

export default EditAppointment;
